import React from "react";
import "../styles/ResourcePages.css";
import BackToTop from "../components/BackToTop";
import SEO from "../components/SEO";

const CountryGuides = () => {
  const handleCounselingClick = () => {
    window.open("https://shorturl.at/uvKtH", "_blank");
  };

  const countries = [
    {
      name: "United States",
      description:
        "Home to world-renowned universities like Harvard, MIT, and Stanford.",
      highlights: [
        "Top-ranked universities",
        "Diverse culture",
        "Strong job market",
      ],
    },
    {
      name: "United Kingdom",
      description:
        "Famous for prestigious institutions like Oxford and Cambridge.",
      highlights: [
        "Rich academic tradition",
        "Shorter program duration",
        "Global recognition",
      ],
    },
    {
      name: "Canada",
      description:
        "Known for high-quality education and welcoming environment.",
      highlights: [
        "Affordable education",
        "Post-study work opportunities",
        "Quality of life",
      ],
    },
    {
      name: "Australia",
      description: "Offers excellent education and a great lifestyle.",
      highlights: [
        "Work while studying",
        "Beautiful environment",
        "Strong economy",
      ],
    },
    {
      name: "Germany",
      description: "Famous for technical education and research opportunities.",
      highlights: [
        "Low or no tuition fees",
        "Strong engineering programs",
        "EU opportunities",
      ],
    },
  ];

  return (
    <div className="resource-page">
      <SEO
        title="Study Abroad Country Guides | USA, UK, Canada, Australia, Germany"
        description="Comprehensive country guides for international students. Explore study destinations in USA, UK, Canada, Australia, and Germany. Get free counseling for choosing your perfect study abroad destination."
        keywords="study abroad countries, USA study guide, UK universities, Canada education, Australia study, Germany universities, international student guides, study destination comparison"
        image="https://grad4grad.com/logo512.png"
        url="https://grad4grad.com/country-guides"
        type="website"
      />
      <div className="resource-hero">
        <h1>Country Guides</h1>
        <p>Explore study destinations and find your perfect fit</p>
      </div>

      <div className="resource-content">
        <div className="resource-intro">
          <h2>Why Choose a Study Abroad Destination?</h2>
          <p>
            Selecting the right country for your studies is crucial for your
            academic and career success. Each country offers unique advantages,
            from educational quality to post-study opportunities.
          </p>
          <button className="cta-button" onClick={handleCounselingClick}>
            Book Free One-on-One Counseling
          </button>
        </div>

        <div className="country-grid">
          {countries.map((country, index) => (
            <div key={index} className="country-card">
              <h3>{country.name}</h3>
              <p>{country.description}</p>
              <div className="highlights">
                <h4>Key Highlights:</h4>
                <ul>
                  {country.highlights.map((highlight, idx) => (
                    <li key={idx}>{highlight}</li>
                  ))}
                </ul>
              </div>
              <button
                className="learn-more-button"
                onClick={handleCounselingClick}
              >
                Get Detailed Guide
              </button>
            </div>
          ))}
        </div>

        <div className="counseling-cta">
          <h2>Need Help Choosing Your Study Destination?</h2>
          <p>
            Book a <strong>FREE</strong> one-on-one counseling session with our
            expert counselors. They'll help you make the right choice based on
            your profile, preferences, and career goals. No hidden charges - our
            guidance is completely free!
          </p>
          <button className="cta-button" onClick={handleCounselingClick}>
            Book Your Free Counseling Session
          </button>
        </div>
      </div>
      <BackToTop />
    </div>
  );
};

export default CountryGuides;
